/**
 * BlockingAlertModal
 *
 * Modal bloqueante para alertas críticos que requerem ação imediata
 * (ex: cloud_api_token_invalid). Não permite fechar sem agir ou
 * clicar "Lembrar mais tarde".
 */

import React from 'react';
import { Modal } from 'react-bootstrap';
import { IconAlertCircle } from '@tabler/icons-react';
import { useChannelAlerts } from '../../contexts/ChannelAlertsContext';
import {
  BLOCKING_EVENTS,
  resolveAlertCTA,
  EVENT_LABELS,
} from './alertConfig';

const BlockingAlertModal = ({ onCTA, filters = {} }) => {
  const { alerts, markRead, dismiss } = useChannelAlerts(filters);

  const blocker = alerts.find(
    (a) => !a.read && BLOCKING_EVENTS.has(a.event),
  );

  if (!blocker) return null;

  const cta = resolveAlertCTA(blocker);
  const label = EVENT_LABELS[blocker.event] || blocker.event;

  const handleAction = () => {
    if (cta && onCTA) onCTA(cta.action, blocker);
    markRead(blocker.id);
  };

  const handleSnooze = () => {
    // Marca como lido — vai voltar no próximo evento (e a beat task de
    // backend redispara periodicamente quando o problema persiste).
    markRead(blocker.id);
    dismiss(blocker.id);
  };

  return (
    <Modal show centered backdrop="static" keyboard={false}>
      <Modal.Body style={{ padding: 32, textAlign: 'center' }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: '#fef2f2',
            margin: '0 auto 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconAlertCircle size={32} style={{ color: '#dc2626' }} />
        </div>
        <h4 style={{ marginBottom: 8, fontSize: 18 }}>{label}</h4>
        <p style={{ color: '#6b7280', marginBottom: 24, lineHeight: 1.5 }}>
          {blocker.message}
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={handleSnooze}
            style={{
              padding: '10px 16px',
              border: '1px solid #e5e7eb',
              background: '#fff',
              borderRadius: 8,
              fontSize: 14,
              cursor: 'pointer',
              color: '#6b7280',
            }}
          >
            Lembrar mais tarde
          </button>
          {cta && (
            <button
              type="button"
              onClick={handleAction}
              style={{
                padding: '10px 16px',
                border: 'none',
                background: '#dc2626',
                color: '#fff',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {cta.label}
            </button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BlockingAlertModal;
